import DictionaryModal from "./DictionaryModal";
export default DictionaryModal;
